let dataNav = localStorage.navigation;
let dat = [];
if (dataNav !== undefined || dataNav != null || dataNav != "") {
  let nav = JSON.parse(localStorage.navigation);
  let viewNavigation = JSON.parse(localStorage.viewNavigation);
  //if (viewNavigation != true) {
  localStorage.setItem("viewNavigation", true);
  console.log(nav);
  let _navDashboard = nav[0].Dashboard;
  let _navApproval = nav[0].Approval;
  let _navApprovalVeca = nav[0].ApprovalVeca;
  let _navBudget = nav[0].Budget;
  let _navCoalStock = nav[0].CoalStock;
  let _navHaulingInfo = nav[0].HaulingInfo;
  let _navPurchaseOrder = nav[0].PurchaseOrder;
  let _navStockAdjustment = nav[0].StockAdjustment;
  let _navApprovalHistory = nav[0].ApprovalHistory;
  let _navBudgetMonitoring = nav[0].BudgetMonitoring;
  let _navCoalInventory = nav[0].CoalInventory;
  let _navDischarge = nav[0].Discharge;
  let _navLoading = nav[0].Loading;
  let _navJobList = nav[0].JobList;
  let _navFundRequest = nav[0].FundRequest;
  let _navDashboardCoalProduction = nav[0].DashboardCoalProduction;
  let _navDashboardProfitLoss = nav[0].DashboardProfitLoss;
  let _navDashboardCoalSales = nav[0].DashboardCoalSales;
  let _navDashboardHauling = nav[0].DashboardHauling;
  let _navDashboardHaulingSite = nav[0].DashboardHaulingSite;
  let _navDashboardHrm = nav[0].DashboardHrm;
  let _navApprovalNotes = nav[0].ApprovalNotes;
  let _navDashboardMiningOperation = nav[0].DashboardMiningOperation;
  let _navQrCode = nav[0].QrCode;
  let _navDashboardProduction = nav[0].DashboardProduction;

  var _home = {
    _name: "CSidebarNavItem",
    name: "Home",
    to: "/HOME",
    icon: "cil-star",
  };

  var _pl = {
    name: "Profit and Loss",
    to: "/ProfitLoss",
  };
  var _cs = {
    name: "Coal Sales",
    to: "/CoalSales",
  };
  var _cp = {
    name: "Coal Production",
    to: "/CoalProduction",
  };

  var _ha = {
    name: "Hauling Discharge",
    to: "/DashboardHauling",
  };
  var _dmo = {
    name: "Mining Operation",
    to: "/DashboardMiningOperation",
  };
  var _st = {
    name: "Hauling Site",
    to: "/DashboardHaulingSite",
  };
  var _dp = {
    name: "Production",
    to: "/DashboardProduction",
  };
  var _hrm = {
    name: "HRM",
    to: "/DashboardHrm",
  };

  var _dashboard = {
    _name: "CSidebarNavDropdown",
    name: "Dashboard",
    route: "/dashboard",
    icon: "cil-chart-pie",
    items: [],
  };

  var _approve = {
    name: "Pending Approval",
    to: "/approval",
  };
  var _approveVeca = {
    name: "Approval Veca",
    to: "/ApprovalVeca",
  };
  var _historyVeca = {
    name: "Approval History Veca",
    to: "/HistoryVeca",
  };
  var _appHistory = {
    name: "History",
    to: "/History",
  };
  var _appNotes = {
    name: "Notes",
    to: "/Notes",
  };

  var _approval = {
    _name: "CSidebarNavDropdown",
    name: "Approval",
    route: "/approval",
    icon: "cil-list",
    items: [],
  };
  var _budget = {
    _name: "CSidebarNavItem",
    name: "Budget",
    to: "/Budget",
    icon: "cil-dollar",
  };

  var _haulingInfo1 = {
    name: "Hauling Info",
    to: "/hauling",
  };

  var _CoalInventory1 = {
    name: "Coal Inventory",
    to: "/CoalInventory",
  };

  var _coalInventory = {
    _name: "CSidebarNavDropdown",
    name: "Coal Stock",
    to: "/CoalInventory",
    icon: "cil-basket",
    items: [],
    //items: [
    //    //{
    //    //    name: 'Coal Inventory',
    //    //    to: '/CoalInventory'
    //    //},
    //    //{
    //    //    name: 'Hauling Info',
    //    //    to: '/hauling'
    //    //}
    //]
  };
  var _profile = {
    _name: "CSidebarNavItem",
    name: "Profile",
    to: "/Profile",
    icon: "cil-user",
  };
  var _logout = {
    _name: "CSidebarNavItem",
    name: "Logout",
    to: "/Logout",
    icon: "cil-settings",
  };

  dat.push(_home);
  if (_navDashboard == true) {
    dat.push(_dashboard);
    if (_navDashboardProfitLoss == true) {
      _dashboard.items.push(_pl);
    }
    if (_navDashboardCoalProduction == true) {
      _dashboard.items.push(_cp);
    }
    if (_navDashboardCoalSales == true) {
      _dashboard.items.push(_cs);
    }
    if (_navDashboardHauling == true) {
      _dashboard.items.push(_ha);
    }
    if (_navDashboardHaulingSite == true) {
      _dashboard.items.push(_st);
    }
    if (_navDashboardProduction == true) {
      _dashboard.items.push(_dp);
    }
    if (_navDashboardMiningOperation == true) {
      _dashboard.items.push(_dmo);
    }
    if (_navDashboardHrm == true) {
      _dashboard.items.push(_hrm);
    }
  }
  if (_navApproval == true) {
    dat.push(_approval);
    if (_navApprovalVeca == true) {
      _approval.items.push(_approveVeca);
      _approval.items.push(_historyVeca);
    }
    _approval.items.push(_approve);
    if (_navApprovalHistory == true) {
      _approval.items.push(_appHistory);
    }

    //if (_navApprovalNotes == true) {
    //    _approval.items.push(_appNotes);
    //}
  }
  if (_navBudget == true) {
    dat.push(_budget);
  }

  if (_navCoalStock == true) {
    dat.push(_coalInventory);
    if (_navCoalInventory == true) {
      _coalInventory.items.push(_CoalInventory1);
    }
    if (_navHaulingInfo == true) {
      _coalInventory.items.push(_haulingInfo1);
    }
  }
  dat.push(_profile);
  dat.push(_logout);
} else {
}

_home;
let x =
  "_name: 'CSidebarNav',_children: [ { _name: 'CSidebarNavItem',name: 'Dashboard',to: '/dashboard',icon: 'cil-speedometer',badge: {color: 'primary',text: 'NEW'}}]'";
export default [
  {
    _name: "CSidebarNav",
    _children: dat,
    //_children: dat.sort((a, b) => a.name.localeCompare(b.name))
  },
];
